import { SET_VISIBLE } from './actionTypes';
import store from "../store";

export function setProdModeModalVisible(toggle) {
  store.dispatch({
    type: SET_VISIBLE,
    payload: {toggle},
  });
}